import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatExpansionModule } from '@angular/material/expansion';
import { IconComponent } from 'src/app/shared/components/icon/icon.component';
import { FormGroup } from '@angular/forms';

@Component({
    selector: 'mg-marks-help',
    standalone: true,
    imports: [CommonModule, MatExpansionModule, IconComponent],
    templateUrl: './marks-help.component.html',
    styleUrls: ['./marks-help.component.scss'],
})

export class MarksHelpComponent {
    request: FormGroup;
    @Input() selectedDateLabel: string = '';
    @Output() volver = new EventEmitter<void>();

    sections: {
        title: string;
        hasIcons?: boolean;
        hasChecks?: boolean;
        items: { label: string; icon?: string; badgeClass?: string; description?: string }[]
    }[] = [
            {
                title: '¿Qué es la Regularización de Marcas?',
                hasIcons: false,
                hasChecks: true,
                items: [
                    { label: 'Es el proceso de corregir o completar tus marcaciones cuando hay errores u omisiones.' },
                    { label: 'Te permite registrar marcas que faltaron, editar o eliminar marcas incorrectas.' },
                    { label: 'Todas las regularizaciones requieren aprobación de tu líder.' },
                ]
            },
            {
                title: 'Pasos para Regularizar',
                hasIcons: false,
                hasChecks: true,
                items: [
                    { label: 'Selecciona la fecha que necesitas regularizar en el calendario de la izquierda.' },
                    { label: 'Revisa tus marcaciones del día en la sección central (Consulta tus marcaciones).' },
                    { label: 'Haz clic en "Nueva Solicitud" para entrar al panel de regularización.' },
                    { label: 'Selecciona la marcación a modificar o crea una nueva marcación.' },
                    { label: 'Realiza la acción deseada: registrar, editar o eliminar.' },
                    { label: 'Completa los detalles de tu solicitud (motivo y justificación si es necesario).' },
                    { label: 'Revisa todas tus acciones agregadas antes de enviar.' },
                    { label: 'Haz clic en "Enviar" y espera la aprobación de tu líder.' },
                ]
            },
            {
                title: 'Tipos de Acciones',
                hasIcons: false,
                items: [
                    { label: 'Registrar', badgeClass: 'bg-mg-green-light text-mg-green-dark border border-mg-green-dark', description: 'Crear una marcación que no existía. Útil cuando olvidaste marcar entrada o salida.' },
                    { label: 'Editar', badgeClass: 'bg-mg-main-blue-light text-mg-main-blue-dark border border-mg-main-blue', description: 'Modificar la hora de una marcación existente. Corrige marcas con hora incorrecta.' },
                    { label: 'Eliminar', badgeClass: 'bg-mg-red-light text-mg-red-dark border border-mg-red-dark', description: 'Solicitar eliminación de una marcación. Usa esto para marcas duplicadas o erróneas.' },
                ]
            },
            {
                title: 'Estados de Solicitudes',
                hasIcons: false,
                items: [
                    { label: 'Pendiente', badgeClass: 'bg-mg-sunshine-light text-mg-sunshine-dark border border-mg-sunshine-dark', description: 'Tu solicitud está en revisión. Tu supervisor evaluará si cumple con los requisitos.' },
                    { label: 'Aprobada', badgeClass: 'bg-mg-green-light text-mg-green-dark border border-mg-green-dark', description: 'Tu solicitud fue aceptada. El cambio se ha registrado en tu historia de marcaciones.' },
                    { label: 'Rechazada', badgeClass: 'bg-mg-red-light text-mg-red-dark border border-mg-red-dark', description: 'Tu solicitud fue denegada. Se mantienen las marcaciones originales. Puedes intentar nuevamente con más justificación.' },
                ]
            },
            {
                title: 'Métodos de Marcación',
                hasIcons: true,
                items: [
                    { badgeClass: 'bg-mg-main-blue-light text-mg-main-blue-dark border border-mg-main-blue', icon: 'computer', label: 'Sistema Smart (Web)' },
                    { badgeClass: 'bg-mg-main-blue-light text-mg-main-blue-dark border border-mg-main-blue', icon: 'mobile_hand_left', label: 'Sistema Smart (Móvil)' },
                    { badgeClass: 'bg-mg-main-blue-light text-mg-main-blue-dark border border-mg-main-blue', icon: 'frame_person', label: 'Biométrico Facial' },
                    { badgeClass: 'bg-mg-main-blue-light text-mg-main-blue-dark border border-mg-main-blue', icon: 'fingerprint', label: 'Biométrico Huella' },
                    { badgeClass: 'bg-mg-main-blue-light text-mg-main-blue-dark border border-mg-main-blue', icon: 'receipt_long', label: 'Solicitud' },
                ]
            },
            {
                title: 'Información sobre Horas Activas',
                hasIcons: false,
                hasChecks: true,
                items: [
                    { label: 'Se calcula sumando los intervalos completos (con inicio y fin).' },
                    { label: 'Si el intervalo no está completo (falta inicio o fin), no se contabiliza el mismo.' }
                ]
            },
            {
                title: 'Restricciones Importantes',
                hasIcons: false,
                hasChecks: true,
                items: [
                    { label: 'No puedes regularizar fechas anteriores al último cierre de planilla. Comunícate con Recursos Humanos para excepciones.' },
                    { label: 'Solo puedes tener una solicitud pendiente por jornada. Debes esperar aprobación antes de crear otra o en todo caso, anularla si está pendiente.' },
                    { label: 'Todas las solicitudes quedan registradas en tu historia para trazabilidad y auditoría.' },
                ]
            },
        ];
}